
export const XIcons = ({size="18"}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 1.5L16 15.5M2 15.5L16 1.5" stroke="#777777" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}


